module.exports = __webpack_public_path__ + "img/汉熵数据智能融合平台.63b10380.png";